"use strict";

const strf = require("./string.format.js");

const SessionModel = require("./models/event.session.js");
const UtmModel = require("./models/event.session.utm.js");

/*
 *
 * Session management
 *
 */

class MetaStreamIOSession {
  constructor({
    constants,
    date,
    environment,
    logger,
    network,
    sessionLength,
    utility,
  } = {}) {
    this.constant = constants;
    this.date = date;
    this.environment = environment;
    this.logger = logger;
    this.network = network;
    this.session_length = sessionLength
      ? sessionLength
      : this.constant.MetaStreamIO_SessionLengthSeconds;
    this.session = new SessionModel();
    this.utility = utility;
  }

  reset() {
    this.session = new SessionModel();
  }

  generateNewSessionId(session_id) {
    if (session_id) {
      return session_id;
    } else {
      return this.utility.generateRandomId();
    }
  }

  setSource(source = null) {
    this.session.source = source ? source : null;
    return this.session.source;
  }

  setUTM({
    utm_source = null,
    utm_medium = null,
    utm_campaign = null,
    utm_term = null,
    utm_content = null,
  } = {}) {
    this.session.utm = new UtmModel({
      utm_source: utm_source ? utm_source : null,
      utm_medium: utm_medium ? utm_medium : null,
      utm_campaign: utm_campaign ? utm_campaign : null,
      utm_term: utm_term ? utm_term : null,
      utm_content: utm_content ? utm_content : null,
    }).list();
    return this.session.utm;
  }

  createNewSession({
    session_id = null,
    session_source = null,
    session_utm = null,
  } = {}) {
    let _id, _source, _start_time, _utm;

    try {
      _id = this.generateNewSessionId(session_id);
    } catch (err) {
      this.logger.warn(
        "session",
        "<createNewSession> could not generate / set new id: " + err
      );
      _id = null;
    }

    try {
      _source = session_source ? session_source : null;
    } catch {
      source = null;
    }

    try {
      _start_time = this.date.getEventTimestamp();
    } catch {
      _start_time = null;
    }

    try {
      _utm = this.setUTM(session_utm);
    } catch (err) {
      this.logger.warn("session", "could not set session UTM: " + err);
    }

    this.session = new SessionModel({
      id: _id,
      source: _source,
      start_time: _start_time,
      utm: _utm,
    });
  }

  logSession({ last_event_time = null } = {}) {
    if (last_event_time) {
      if (!this.checkSessionIsValid(last_event_time)) {
        this.logger.warn("session", "session expired - starting new session");
        this.createNewSession();
      }
    }
    return this.utility.copyObject(this.session);
  }

  checkSessionIsValid(last_event_time) {
    try {
      let current_time = this.date.getEventTimestamp();
      let session_length_seconds = (current_time - last_event_time) / 1e6;
      this.logger.log(
        "session",
        "<checkSessionIsValid> current session length: ",
        session_length_seconds
      );
      if (!last_event_time || session_length_seconds > this.session.length) {
        return false;
      } else {
        return true;
      }
    } catch (err) {
      this.logger.log(
        "session",
        "<checkSessionIsValid> problem checking session length: ",
        err
      );
      return false;
    }
  }
}

module.exports = MetaStreamIOSession;
